import { EventBase } from "../event/event-base";
import { IndividualViewBase } from "./individual-view-base";

export class IndividualEventBase extends IndividualViewBase {
    birthEvent: EventBase;
    deathEvent: EventBase;
  }